import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        select: {
            margin: '0 5px',
            width: '-webkit-fill-available',
            maxWidth: '250px',
        },
        icon: {
            fill: theme.palette.getContrastText(theme.palette.primary.main),
        },
        root: {
            color: theme.palette.getContrastText(theme.palette.primary.main),
            '& label.Mui-focused': {
                color: theme.palette.getContrastText(
                    theme.palette.primary.main
                ),
            },
            '& .MuiFormLabel-root': {
                color: theme.palette.getContrastText(
                    theme.palette.primary.main
                ),
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: theme.palette.getContrastText(
                    theme.palette.primary.main
                ),
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: theme.palette.getContrastText(
                        theme.palette.primary.main
                    ),
                },
                '&:hover fieldset': {
                    borderColor: theme.palette.getContrastText(
                        theme.palette.primary.main
                    ),
                },
                '&.Mui-focused fieldset': {
                    borderColor: theme.palette.getContrastText(
                        theme.palette.primary.main
                    ),
                },
            },
        },

        listItemIcon: {
            color: theme.palette.text.primary,
            minWidth: 32,
            '& svg': {
                fill: 'currentColor',
                color: 'inherit',
            },
        },

        menuItem: {
            '&:hover $listItemIcon, &.Mui-selected $listItemIcon, &.Mui-focusVisible $listItemIcon':
                {
                    color: theme.palette.getContrastText(
                        theme.palette.primary.main
                    ),
                    '& svg': {
                        fill: 'currentColor',
                        color: 'inherit',
                    },
                },
        },
        valueWrapper: {
            display: 'flex',
            alignItems: 'center',
        },
        valueIcon: {
            display: 'flex',
            marginRight: 8,
            color: 'inherit',
        },
    })
);
